"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _translations = require("../../libs/translationsUtils/translations");

var translation = function translation() {
  return {
    'editor': 'Rich Text Editor',
    'editorPanel': 'Rich Text Editor panel',
    'common': {
      'editorHelp': 'Press ALT 0 for help',
      'browseServer': 'Browse Server',
      'url': 'URL',
      'protocol': 'Protocol',
      'upload': 'Upload',
      'uploadSubmit': 'Send it to the Server',
      'image': (0, _translations.t)('Forum', 'wysiwyg.image.btn.title'),
      'flash': 'Flash',
      'form': 'Form',
      'checkbox': 'Checkbox',
      'radio': 'Radio Button',
      'textField': 'Text Field',
      'textarea': 'Textarea',
      'hiddenField': 'Hidden Field',
      'button': 'Button',
      'select': 'Selection Field',
      'imageButton': 'Image Button',
      'notSet': '<not set>',
      'id': 'Id',
      'name': 'Name',
      'langDir': 'Language Direction',
      'langDirLtr': 'Left to Right (LTR)',
      'langDirRtl': 'Right to Left (RTL)',
      'langCode': 'Language Code',
      'longDescr': 'Long Description URL',
      'cssClass': 'Stylesheet Classes',
      'advisoryTitle': 'Advisory Title',
      'cssStyle': 'Style',
      'ok': (0, _translations.t)('Common', 'editor.add'),
      'cancel': (0, _translations.t)('Forum', 'Cancel'),
      'close': 'Close',
      'preview': 'Preview',
      'resize': 'Resize',
      'generalTab': 'General',
      'advancedTab': 'Advanced',
      'validateNumberFailed': 'This value is not a number.',
      'confirmNewPage': 'Any unsaved changes to this content will be lost. Are you sure you want to load new page?',
      'confirmCancel': 'You have changed some options. Are you sure you want to close the dialog window?',
      'options': 'Options',
      'target': 'Target',
      'targetNew': 'New Window (_blank)',
      'targetTop': 'Topmost Window (_top)',
      'targetSelf': 'Same Window (_self)',
      'targetParent': 'Parent Window (_parent)',
      'langDirLTR': 'Left to Right (LTR)',
      'langDirRTL': 'Right to Left (RTL)',
      'styles': 'Style',
      'cssClasses': 'Stylesheet Classes',
      'width': 'Width',
      'height': 'Height',
      'align': 'Alignment',
      'left': 'Left',
      'right': 'Right',
      'center': 'Center',
      'justify': 'Justify',
      'alignLeft': 'Align Left',
      'alignRight': 'Align Right',
      'alignCenter': 'Align Center',
      'alignTop': 'Top',
      'alignMiddle': 'Middle',
      'alignBottom': 'Bottom',
      'alignNone': 'None',
      'invalidValue': 'Invalid value.',
      'invalidHeight': 'Height must be a number.',
      'invalidWidth': 'Width must be a number.',
      'invalidLength': 'Value specified for the "%1" field must be a positive number with or without a valid measurement unit (%2).',
      'invalidCssLength': 'Value specified for the "%1" field must be a positive number with or without a valid CSS measurement unit (px, %, in, cm, mm, em, ex, pt, or pc).',
      'invalidHtmlLength': 'Value specified for the "%1" field must be a positive number with or without a valid HTML measurement unit (px or %).',
      'invalidInlineStyle': 'Value specified for the inline style must consist of one or more tuples with the format of "name : value", separated by semi-colons.',
      'cssLengthTooltip': 'Enter a number for a value in pixels or a number with a valid CSS unit (px, %, in, cm, mm, em, ex, pt, or pc).',
      'unavailable': '%1<span class="cke_accessibility">, unavailable</span>',
      'keyboard': {
        '8': 'Backspace',
        '13': 'Enter',
        '16': 'Shift',
        '17': 'Ctrl',
        '18': 'Alt',
        '32': 'Space',
        '35': 'End',
        '36': 'Home',
        '46': 'Delete',
        '112': 'F1',
        '113': 'F2',
        '114': 'F3',
        '115': 'F4',
        '116': 'F5',
        '117': 'F6',
        '118': 'F7',
        '119': 'F8',
        '120': 'F9',
        '121': 'F10',
        '122': 'F11',
        '123': 'F12',
        '124': 'F13',
        '125': 'F14',
        '126': 'F15',
        '127': 'F16',
        '128': 'F17',
        '129': 'F18',
        '130': 'F19',
        '131': 'F20',
        '132': 'F21',
        '133': 'F22',
        '134': 'F23',
        '135': 'F24',
        '224': 'Command'
      },
      'keyboardShortcut': 'Keyboard shortcut',
      'optionDefault': 'Default'
    },
    'notification': {
      'closed': 'Notification closed.'
    },
    'toolbar': {
      'toolbarCollapse': 'Collapse Toolbar',
      'toolbarExpand': 'Expand Toolbar',
      'toolbarGroups': {
        'document': 'Document',
        'clipboard': 'Clipboard/Undo',
        'editing': 'Editing',
        'forms': 'Forms',
        'basicstyles': 'Basic Styles',
        'paragraph': 'Paragraph',
        'links': 'Links',
        'insert': 'Insert',
        'styles': 'Styles',
        'colors': 'Colors',
        'tools': 'Tools'
      },
      'toolbars': 'Editor toolbars'
    },
    'clipboard': {
      'copy': 'Copy',
      'copyError': "Your browser security settings don't permit the editor to automatically execute copying operations. Please use the keyboard for that (Ctrl/Cmd+C).",
      'cut': 'Cut',
      'cutError': "Your browser security settings don't permit the editor to automatically execute cutting operations. Please use the keyboard for that (Ctrl/Cmd+X).",
      'paste': 'Paste',
      'pasteNotification': 'Press %1 to paste. Your browser doesn‘t support pasting with the toolbar button or context menu option.',
      'pasteArea': 'Paste Area',
      'pasteMsg': 'Paste your content inside the area below and press OK.'
    },
    'undo': {
      'redo': 'Redo',
      'undo': 'Undo'
    },
    'autoembed': {
      'embeddingInProgress': 'Trying to embed pasted URL...',
      'embeddingFailed': 'This URL could not be automatically embedded.'
    },
    'basicstyles': {
      'bold': (0, _translations.t)('Forum', 'wysiwyg.b.btn.title'),
      'italic': (0, _translations.t)('Forum', 'wysiwyg.i.btn.title'),
      'strike': 'Strikethrough',
      'subscript': 'Subscript',
      'superscript': 'Superscript',
      'underline': (0, _translations.t)('Forum', 'wysiwyg.u.btn.title')
    },
    'blockquote': {
      'toolbar': (0, _translations.t)('Forum', 'wysiwyg.quote.btn.title')
    },
    'widget': {
      'move': 'Click and drag to move',
      'label': '%1 widget'
    },
    'codesnippet': {
      'button': 'Insert Code Snippet',
      'codeContents': (0, _translations.t)('Forum', 'wysiwyg.code.btn.title'),
      'emptySnippetError': 'A code snippet cannot be empty.',
      'language': (0, _translations.t)('Common', 'editor.code.language'),
      'title': (0, _translations.t)('Forum', 'wysiwyg.code.btn.title'),
      'pathName': 'code snippet'
    },
    'colorbutton': {
      'auto': 'Automatic',
      'bgColorTitle': (0, _translations.t)('Common', 'editor.background.color'),
      'colors': {
        '000': 'Black',
        '800000': 'Maroon',
        '8B4513': 'Saddle Brown',
        '2F4F4F': 'Dark Slate Gray',
        '008080': 'Teal',
        '000080': 'Navy',
        '4B0082': 'Indigo',
        '696969': 'Dark Gray',
        'B22222': 'Fire Brick',
        'A52A2A': 'Brown',
        'DAA520': 'Golden Rod',
        '006400': 'Dark Green',
        '40E0D0': 'Turquoise',
        '0000CD': 'Medium Blue',
        '800080': 'Purple',
        '808080': 'Gray',
        'F00': 'Red',
        'FF8C00': 'Dark Orange',
        'FFD700': 'Gold',
        '008000': 'Green',
        '0FF': 'Cyan',
        '00F': 'Blue',
        'EE82EE': 'Violet',
        'A9A9A9': 'Dim Gray',
        'FFA07A': 'Light Salmon',
        'FFA500': 'Orange',
        'FFFF00': 'Yellow',
        '00FF00': 'Lime',
        'AFEEEE': 'Pale Turquoise',
        'ADD8E6': 'Light Blue',
        'DDA0DD': 'Plum',
        'D3D3D3': 'Light Grey',
        'FFF0F5': 'Lavender Blush',
        'FAEBD7': 'Antique White',
        'FFFFE0': 'Light Yellow',
        'F0FFF0': 'Honeydew',
        'F0FFFF': 'Azure',
        'F0F8FF': 'Alice Blue',
        'E6E6FA': 'Lavender',
        'FFF': 'White',
        '1ABC9C': 'Strong Cyan',
        '2ECC71': 'Emerald',
        '3498DB': 'Bright Blue',
        '9B59B6': 'Amethyst',
        '4E5F70': 'Grayish Blue',
        'F1C40F': 'Vivid Yellow',
        '16A085': 'Dark Cyan',
        '27AE60': 'Dark Emerald',
        '2980B9': 'Strong Blue',
        '8E44AD': 'Dark Violet',
        '2C3E50': 'Desaturated Blue',
        'F39C12': 'Orange',
        'E67E22': 'Carrot',
        'E74C3C': 'Pale Red',
        'ECF0F1': 'Bright Silver',
        '95A5A6': 'Light Grayish Cyan',
        'DDD': 'Light Gray',
        'D35400': 'Pumpkin',
        'C0392B': 'Strong Red',
        'BDC3C7': 'Silver',
        '7F8C8D': 'Grayish Cyan',
        '999': 'Dark Gray'
      },
      'more': 'More Colors...',
      'panelTitle': 'Colors',
      'textColorTitle': (0, _translations.t)('Common', 'editor.text.color')
    },
    'colordialog': {
      'clear': 'Clear',
      'highlight': 'Highlight',
      'options': 'Color Options',
      'selected': 'Selected Color',
      'title': 'Select color'
    },
    'contextmenu': {
      'options': 'Context Menu Options'
    },
    'embedbase': {
      'pathName': 'media object',
      'title': (0, _translations.t)('Forum', 'wysiwyg.embed.btn.title'),
      'button': 'Insert Media Embed',
      'unsupportedUrlGiven': 'The specified URL is not supported.',
      'unsupportedUrl': 'The URL {url} is not supported by Media Embed.',
      'fetchingFailedGiven': (0, _translations.t)('Forum', 'o_embed.error.error_service_not_supported'),
      'fetchingFailed': 'Failed to fetch content for {url}.',
      'fetchingOne': 'Fetching oEmbed response...',
      'fetchingMany': 'Fetching oEmbed responses, {current} of {max} done...'
    },
    'horizontalrule': {
      'toolbar': 'Insert Horizontal Line'
    },
    'indent': {
      'indent': 'Increase Indent',
      'outdent': 'Decrease Indent'
    },
    'fakeobjects': {
      'anchor': 'Anchor',
      'flash': 'Flash Animation',
      'hiddenfield': 'Hidden Field',
      'iframe': 'IFrame',
      'unknown': 'Unknown Object'
    },
    'link': {
      'acccessKey': 'Access Key',
      'advanced': 'Advanced',
      'advisoryContentType': 'Advisory Content Type',
      'advisoryTitle': 'Advisory Title',
      'anchor': {
        'toolbar': 'Anchor',
        'menu': 'Edit Anchor',
        'title': 'Anchor Properties',
        'name': 'Anchor Name',
        'errorName': 'Please type the anchor name',
        'remove': 'Remove Anchor'
      },
      'anchorId': 'By Element Id',
      'anchorName': 'By Anchor Name',
      'charset': 'Linked Resource Charset',
      'cssClasses': 'Stylesheet Classes',
      'download': 'Force Download',
      'displayText': (0, _translations.t)('Common', 'editor.link.display.text'),
      'emailAddress': 'E-Mail Address',
      'emailBody': 'Message Body',
      'emailSubject': 'Message Subject',
      'id': 'Id',
      'info': 'Link Info',
      'langCode': 'Language Code',
      'langDir': 'Language Direction',
      'langDirLTR': 'Left to Right (LTR)',
      'langDirRTL': 'Right to Left (RTL)',
      'menu': 'Edit Link',
      'name': 'Name',
      'noAnchors': '(No anchors available in the document)',
      'noEmail': 'Please type the e-mail address',
      'noUrl': 'Please type the link URL',
      'noTel': 'Please type the phone number',
      'other': '<other>',
      'phoneNumber': 'Phone number',
      'popupDependent': 'Dependent (Netscape)',
      'popupFeatures': 'Popup Window Features',
      'popupFullScreen': 'Full Screen (IE)',
      'popupLeft': 'Left Position',
      'popupLocationBar': 'Location Bar',
      'popupMenuBar': 'Menu Bar',
      'popupResizable': 'Resizable',
      'popupScrollBars': 'Scroll Bars',
      'popupStatusBar': 'Status Bar',
      'popupToolbar': 'Toolbar',
      'popupTop': 'Top Position',
      'rel': 'Relationship',
      'selectAnchor': 'Select an Anchor',
      'styles': 'Styles',
      'tabIndex': 'Tab Index',
      'target': 'Target',
      'targetFrame': '<frame>',
      'targetFrameName': 'Target Frame Name',
      'targetPopup': '<popup window>',
      'targetPopupName': 'Popup Window Name',
      'title': (0, _translations.t)('Forum', 'wysiwyg.links.btn.title'),
      'toAnchor': 'Link to anchor in the text',
      'toEmail': 'E-mail',
      'toUrl': (0, _translations.t)('Forum', 'wysiwyg.features.links.link_input--URL'),
      'toPhone': 'Phone',
      'toolbar': (0, _translations.t)('Forum', 'wysiwyg.links.btn.title'),
      'type': 'Link Type',
      'unlink': 'Unlink',
      'upload': 'Upload'
    },
    'list': {
      'bulletedlist': (0, _translations.t)('Forum', 'wysiwyg.ul.btn.title'),
      'numberedlist': (0, _translations.t)('Forum', 'wysiwyg.ol.btn.title')
    },
    'magicline': {
      'title': 'Insert paragraph here'
    },
    'pastefromword': {
      'confirmCleanup': 'The text you want to paste seems to be copied from Word. Do you want to clean it before pasting?',
      'error': 'It was not possible to clean up the pasted data due to an internal error',
      'title': 'Paste from Word',
      'toolbar': 'Paste from Word'
    },
    'pastetext': {
      'button': 'Paste as plain text',
      'pasteNotification': 'Press %1 to paste. Your browser doesn‘t support pasting with the toolbar button or context menu option.',
      'title': 'Paste as Plain Text'
    },
    'removeformat': {
      'toolbar': 'Remove Format'
    },
    'sourcearea': {
      'toolbar': 'Source'
    },
    'stylescombo': {
      'label': (0, _translations.t)('Common', 'editor.styles'),
      'panelTitle': (0, _translations.t)('Common', 'editor.formatting.styles'),
      'panelTitle1': 'Block Styles',
      'panelTitle2': 'Inline Styles',
      'panelTitle3': 'Object Styles'
    },
    'table': {
      'border': 'Border size',
      'caption': 'Caption',
      'cell': {
        'menu': 'Cell',
        'insertBefore': 'Insert Cell Before',
        'insertAfter': 'Insert Cell After',
        'deleteCell': 'Delete Cells',
        'merge': 'Merge Cells',
        'mergeRight': 'Merge Right',
        'mergeDown': 'Merge Down',
        'splitHorizontal': 'Split Cell Horizontally',
        'splitVertical': 'Split Cell Vertically',
        'title': 'Cell Properties',
        'cellType': 'Cell Type',
        'rowSpan': 'Rows Span',
        'colSpan': 'Columns Span',
        'wordWrap': 'Word Wrap',
        'hAlign': 'Horizontal Alignment',
        'vAlign': 'Vertical Alignment',
        'alignBaseline': 'Baseline',
        'bgColor': 'Background Color',
        'borderColor': 'Border Color',
        'data': 'Data',
        'header': 'Header',
        'yes': 'Yes',
        'no': 'No',
        'invalidWidth': 'Cell width must be a number.',
        'invalidHeight': 'Cell height must be a number.',
        'invalidRowSpan': 'Rows span must be a whole number.',
        'invalidColSpan': 'Columns span must be a whole number.',
        'chooseColor': 'Choose'
      },
      'cellPad': 'Cell padding',
      'cellSpace': 'Cell spacing',
      'column': {
        'menu': 'Column',
        'insertBefore': 'Insert Column Before',
        'insertAfter': 'Insert Column After',
        'deleteColumn': 'Delete Columns'
      },
      'columns': (0, _translations.t)('Common', 'editor.table.columns'),
      'deleteTable': 'Delete Table',
      'headers': (0, _translations.t)('Common', 'editor.table.headers'),
      'headersBoth': (0, _translations.t)('Common', 'editor.table.headers.both'),
      'headersColumn': (0, _translations.t)('Common', 'editor.table.headers.first.column'),
      'headersNone': (0, _translations.t)('Common', 'editor.table.headers.none'),
      'headersRow': (0, _translations.t)('Common', 'editor.table.headers.first.row'),
      'heightUnit': 'height unit',
      'invalidBorder': 'Border size must be a number.',
      'invalidCellPadding': 'Cell padding must be a positive number.',
      'invalidCellSpacing': 'Cell spacing must be a positive number.',
      'invalidCols': 'Number of columns must be a number greater than 0.',
      'invalidHeight': 'Table height must be a number.',
      'invalidRows': 'Number of rows must be a number greater than 0.',
      'invalidWidth': 'Table width must be a number.',
      'menu': 'Table Properties',
      'row': {
        'menu': 'Row',
        'insertBefore': 'Insert Row Before',
        'insertAfter': 'Insert Row After',
        'deleteRow': 'Delete Rows'
      },
      'rows': (0, _translations.t)('Common', 'editor.table.rows'),
      'summary': 'Summary',
      'title': (0, _translations.t)('Common', 'editor.table'),
      'toolbar': 'Table',
      'widthPc': 'percent',
      'widthPx': 'pixels',
      'widthUnit': 'width unit'
    },
    'filetools': {
      'loadError': 'Error occurred during file read.',
      'networkError': 'Network error occurred during file upload.',
      'httpError404': 'HTTP error occurred during file upload (404: File not found).',
      'httpError403': 'HTTP error occurred during file upload (403: Forbidden).',
      'httpError': 'HTTP error occurred during file upload (error status: %1).',
      'noUrlError': 'Upload URL is not defined.',
      'responseError': 'Incorrect server response.'
    },
    'uploadwidget': {
      'abort': 'Upload aborted by the user.',
      'doneOne': 'File successfully uploaded.',
      'doneMany': 'Successfully uploaded %1 files.',
      'uploadOne': 'Uploading file ({percentage}%)...',
      'uploadMany': 'Uploading files, {current} of {max} done ({percentage}%)...'
    },
    'imagebase': {
      'captionPlaceholder': (0, _translations.t)('Common', 'editor.image.caption')
    }
  };
};

var _default = translation;
exports.default = _default;